/**
 * Polyfills for Angular Web Components
 * 
 * This file includes polyfills needed by Angular web components.
 * Zone.js is configured to work properly with custom elements.
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * Custom Elements Polyfills (Optional - for older browsers)
 * Uncomment if you need to support older browsers that don't have native custom elements.
 * 
 * First install: npm install @webcomponents/custom-elements
 * 
 * Then uncomment these lines:
 */
// import '@webcomponents/custom-elements/src/native-shim';
// import '@webcomponents/custom-elements/custom-elements.min';

/**
 * Zone.js configuration for custom elements
 * Must be set BEFORE importing zone.js
 * 
 * This prevents Zone.js from patching custom elements APIs,
 * which can cause conflicts with Angular Elements.
 */
(window as any).__Zone_disable_customElements = true;

/**
 * Zone JS is required by Angular itself.
 */
import 'zone.js';
